/**
 * ID generation utilities
 */

/**
 * Generate a short random ID (9 characters, alphanumeric)
 * Suitable for client-side unique identifiers in React lists, messages, etc.
 */
export const genId = (): string => Math.random().toString(36).substr(2, 9);
